export const DEBUG = false
export const API_ENDPOINT = DEBUG? "http://localhost:8000": "https://ndpc-zik.org"
export const ASSETS_ENDPOINT = API_ENDPOINT